import { Injectable } from '@angular/core';
import { IActivo } from 'modelos/src';
import { MapInstanceFilter } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class VehicleFilterService {
  filterVehiculos(
    vehiculos: IActivo[],
    filtros: MapInstanceFilter | undefined,
  ): IActivo[] {
    if (!vehiculos || vehiculos.length === 0) {
      return [];
    }

    if (!filtros) {
      return vehiculos;
    }

    let vehiculosFiltrados = [...vehiculos];

    if (
      filtros.idsClientesVehiculos &&
      filtros.idsClientesVehiculos.length > 0
    ) {
      vehiculosFiltrados = vehiculosFiltrados.filter(
        (v) =>
          v.idCliente && filtros.idsClientesVehiculos!.includes(v.idCliente),
      );
    }

    if (filtros.gruposVehiculos && filtros.gruposVehiculos.length > 0) {
      vehiculosFiltrados = vehiculosFiltrados.filter(
        (v) => v.idGrupo && filtros.gruposVehiculos!.includes(v.idGrupo),
      );
    }

    if (filtros.funcionVehiculos && filtros.funcionVehiculos.length > 0) {
      vehiculosFiltrados = vehiculosFiltrados.filter(
        (v) => v.funcion && filtros.funcionVehiculos!.includes(v.funcion),
      );
    }

    if (
      filtros.idsVehiculosFiltrados &&
      filtros.idsVehiculosFiltrados.length > 0
    ) {
      vehiculosFiltrados = vehiculosFiltrados.filter(
        (v) => v._id && filtros.idsVehiculosFiltrados!.includes(v._id),
      );
    } else if (filtros.idsVehiculos && filtros.idsVehiculos.length > 0) {
      vehiculosFiltrados = vehiculosFiltrados.filter(
        (v) => v._id && filtros.idsVehiculos!.includes(v._id),
      );
    }

    return vehiculosFiltrados;
  }
}
